interface IFormTitle {
    title: string;
    alignLeft?: boolean;
    marginBottom?: string;
}

/**
 * Common form title.
 */
const FormTitle = (props: IFormTitle) => {

    const marginBottom = props.marginBottom || 'mb-8';

    return (
        <div className={`flex ${ props.alignLeft ? '' : 'justify-center text-center' }`}>
            <h1 className={ `text-2xl text-center font-bold text-gray-700 ${ marginBottom }` }>{ props.title }</h1>
        </div>
    )
};

export default FormTitle;